// referral_type === 3 is a Quick Referral (same rule as Quick Refer page).

export function isQuickReferral(recordOrData) {
  const inner = recordOrData?.data || recordOrData?.Data || recordOrData || {};
  const v = inner.referral_type;
  if (v === null || v === undefined) return false;
  return Number(v) === 3;
}

/** Display label for formatted views and exports. */
export function referralTypeLabel(recordOrData) {
  return isQuickReferral(recordOrData) ? 'Quick' : 'Standard';
}
